var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"mode":"out-in"}},[(!_vm.loading)?_vm._t("default"):_c('div',{staticClass:"loading-indicator-container"},[_c('div',{staticClass:"loading-indicator"})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }